import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;

  label {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
`

export const SelectDifficulty = styled.select`
  margin: 0;
`
